/**
 * Home / Studio launcher grid limits.
 * Saved layouts may still contain larger values; always clamp before render.
 */
export const LAUNCHER_GRID = Object.freeze({
  MIN_COLUMNS: 2,
  MAX_COLUMNS: 6,
  MIN_ROWS: 2,
  MAX_ROWS: 6,
  DEFAULT_COLUMNS: 4,
  DEFAULT_ROWS: 6,
  MIN_PAGE_WIDTH: 520,
  MIN_PAGE_HEIGHT: 460,
  MIN_CELL_WIDTH: 68,
  MIN_CELL_HEIGHT: 76,
});

function clampInt(value, min, max, fallback) {
  if (value == null || value === '') return fallback;
  const n = Number(value);
  if (!Number.isFinite(n)) return fallback;
  return Math.min(max, Math.max(min, Math.round(n)));
}

export function clampGridColumns(value) {
  return clampInt(
    value,
    LAUNCHER_GRID.MIN_COLUMNS,
    LAUNCHER_GRID.MAX_COLUMNS,
    LAUNCHER_GRID.DEFAULT_COLUMNS,
  );
}

export function clampGridRows(value) {
  return clampInt(
    value,
    LAUNCHER_GRID.MIN_ROWS,
    LAUNCHER_GRID.MAX_ROWS,
    LAUNCHER_GRID.DEFAULT_ROWS,
  );
}

export function clampLauncherGrid(columns, rows) {
  return {
    gridColumns: clampGridColumns(columns),
    gridRows: clampGridRows(rows),
  };
}
